import { getLocalizedString } from "@grandvisionhq/utils";
import { getPrices } from "../../../utils/mappers/utils/get-prices.js";
import { createImageUrl } from "../../../utils/mappers/utils/create-image-url.js";
import { createLineItemId } from "../../../utils/mappers/utils/create-line-item-id.js";
import { getProductA11yLabel } from "../../../utils/mappers/utils/get-product-a11y-label.js";
import { getProductSubtitle } from "../../../utils/mappers/utils/get-product-subtitle.js";
import { getProductTitle } from "../../../utils/mappers/utils/get-product-title.js";
import { getAvailability } from "../../../utils/mappers/utils/get-availability.js";
import { getInsurance } from "../../../utils/mappers/utils/get-insurance.js";
const mapProductType = (serverType) => {
  switch (serverType.toLowerCase()) {
    case "frames":
      return "frames";
    case "sunglasses":
      return "sunglasses";
    case "solutions":
      return "solutions";
    case "ready-readers":
      return "ready-readers";
    case "accessories":
      return "accessories";
    default:
      return "sunglasses";
  }
};
const toBaseLineItem = (orderLineItem, intl, options = {}) => {
  const price = getPrices(orderLineItem, intl);
  const id = createLineItemId(orderLineItem);
  const availability = getAvailability(orderLineItem);
  return {
    id,
    lineItemId: id,
    availability,
    quantity: `${intl.getLabel("cart.item.quantity")}: ${orderLineItem.quantity}`,
    sku: orderLineItem.product.sku,
    imageUrl: createImageUrl(orderLineItem.product.mainImage, options),
    title: getProductTitle(orderLineItem, intl),
    displayName: getLocalizedString(orderLineItem.product.name, intl.locale),
    subtitle: getProductSubtitle(orderLineItem, intl),
    altText: getProductA11yLabel(orderLineItem, intl),
    productType: mapProductType(orderLineItem.product.currentProduct?.type || ""),
    ...price,
    insurance: getInsurance(orderLineItem.insurance),
    deliveryEstimation: orderLineItem.deliveryEstimation
  };
};
export {
  toBaseLineItem
};
//# sourceMappingURL=base-line-item.js.map
